import { createComponent } from '@carvana/merch-components';

export const GridWrapper = createComponent('div', {
  className: 'grid w-full grid-cols-2 gap-8 m:grid-cols-4 m:gap-16'
});

export const FeatureCard = createComponent('div', {
  className:
    'target flex h-[72px] h-full items-center justify-start rounded-lg bg-grey-1 p-16 m:p-24'
});
